import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthProvider";
import starY from "../../assets/starY.png";
import starW from "../../assets/starW.png";
import './Rates.scss';
import { AddUserRate } from '../../router/apiServiceFetch';

const Rates = ({ gameId, onClose }) => {
    const [rating, setRating] = useState(0);
    const { userBase } = useAuth();
    const navigate = useNavigate();
    const [comment, setComment] = useState('');
    const [error, setError] = useState('');

    const handleStarClick = (value) => {
        setRating(value);
        setError(''); // Clear error when a star is selected
    };

    const handleSubmit = async () => {
        if (rating === 0) {
            setError('Пожалуйста, выберите оценку.');
            return;
        }
        const date = {
            id: 0,
            userId: userBase.userId,
            gameId: gameId,
            review: comment,
            rate: rating
        }
        await AddUserRate(date)
        setRating(0);
        setComment('');
        onClose();

        // navigate("/profile")
    };

    return (
        <div className="rates-container">
            <h2>Оставьте отзыв</h2>
            <p>Поставьте оценку и оставьте комментарий.</p>

            <div className="stars">
                {[1, 2, 3, 4, 5].map((value) => (

                        <img src={rating >= value ? starY : starW} alt="star" className="star" onClick={() => handleStarClick(value)} />
                  
                ))}
            </div>
            {error && <p className="error">{error}</p>}

            <textarea
                className="comment-box"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Напишите ваш комментарий здесь..."
            ></textarea>
            <div className="confirmation">
                <div className="actions">
                    <button className="submit-button" onClick={() => onClose()}>
                        Закрыть
                    </button>
                </div>
                <div className="actions">
                    <button className="close-button" onClick={handleSubmit}>
                        Спасибо за отзыв
                    </button>
                </div>
            </div>

        </div>
    );
};

export default Rates;
